import { createContext } from 'react';

/**
 * True while a live report renders on its printvel (`LiveReportPrint`, the
 * page behind 'PDF maken'). Paper has no 'volgende'-knop, so widgets that
 * show their items one at a time (carrousel) stack them all instead — see
 * `usePrintDisplayMode`. Defaults to `false` everywhere else.
 *
 * @type {React.Context<boolean>}
 */
const ReportPrintContext = createContext(false);

export default ReportPrintContext;
